import { fetchAPIWithID } from "../config";

export async function newPcds(req) {
  const data = await fetchAPIWithID("/ssm_api_store/Up_NRCnt", req);
  return data;
}
